<div class="content-container mx-auto my-4">
    <h1 class="mt-0">Update your application</h1>

    @if (loading) {
        <ngxh6-loading-or-error></ngxh6-loading-or-error>
    } @else if (gone) {
        <div class="alert alert-warning" role="alert">
            <h4 class="mt-0 h6">This link is no longer valid</h4>
            <p class="mb-0">
                This update link has expired or has already been used. If you still need to make changes to your application, please contact Tiwi Land Council
                and we'll send you a new one.
            </p>
        </div>
    } @else if (notFound) {
        <div class="alert alert-danger" role="alert">We couldn't find that application.</div>
    } @else if (result) {
        <!-- Resubmitted successfully -->
        <div class="alert alert-success" role="alert">
            <h4 class="mt-0">Thanks - your application is back with us</h4>
            <p class="mb-0">Tiwi Land Council will review your updated application and be in touch. You don't need to do anything further.</p>
        </div>
        <div class="d-flex flex-column">
            <a class="btn btn-primary ms-0" [routerLink]="['/permit', result.token]">Check application status</a>
        </div>
    } @else {
        <div class="mb-3">
            <div class="h5 mb-1">{{ permitType }}</div>
        </div>

        @if (locked) {
            <!-- Generic prompt only - the specific note may contain details and is shown after the email gate. -->
            <div class="alert alert-info" role="alert">
                <h4 class="mt-0 h6">Tiwi Land Council needs some more information</h4>
                <p class="mb-0">Confirm your email below to see what's needed and update your application.</p>
            </div>

            <!-- Email-confirm gate -->
            <div class="card mb-3">
                <div class="card-body">
                    <h2 class="h6 mt-0">Confirm it's you</h2>
                    <p class="text-muted">For your privacy, please enter the email address you used on your application before making changes.</p>

                    <form (ngSubmit)="verify()">
                        <div class="mb-3">
                            <label class="form-label" for="edit-verify-email">Email address</label>
                            <input id="edit-verify-email" name="email" type="email" class="form-control" [(ngModel)]="email" autocomplete="email" required />
                        </div>

                        @if (verifyError) {
                            <div class="alert alert-danger" role="alert">{{ verifyError }}</div>
                        }

                        <button type="submit" class="btn btn-primary ms-0" [disabled]="!email || verifying">
                            {{ verifying ? 'Checking…' : 'Continue' }}
                        </button>
                    </form>
                </div>
            </div>
        } @else if (formOpts) {
            @if (needsInfoNote) {
                <div class="alert alert-warning" role="alert">
                    <h4 class="mt-0 h6">What we need from you</h4>
                    <p class="mb-0" style="white-space: pre-line">{{ needsInfoNote }}</p>
                </div>
            }
            <p class="text-muted">
                Please review and update your application below, then resubmit it. Any documents you already uploaded are kept unless you attach new ones.
            </p>
            <ngxh6-form-embed
                [formOpts]="formOpts"
                [model]="editData"
                [options]="{ sticky_actions: false, reload_on_save: false, show_delete: false, show_archive: false }"
                (submitted)="onResubmitted($event)"
            ></ngxh6-form-embed>
        }
    }
</div>
